module.exports = __webpack_public_path__ + "src/ts/g.frame.modules/uiModule/assets/fail_popup_icon.png";